import React from 'react';
import 'typeface-roboto';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { theme } from './utils/theme';
import { BrowserRouter as Router, Route, Switch  } from "react-router-dom";
import Student from './app/student'
import { SnackBarContext } from './context/SnackBarContext';
import { LoaderContext } from './context/LoaderContext';
import { AuthContext } from './context/AuthContext';
import { SnackBar } from './utils/snackbar'
import LoadingOverlay from './utils/loading-overlay'
import AuthModal from './app/student/components/authentication/auth-modal'


 export default class App extends React.Component {
  state = {
    snackbarText: null,
    snackBar: false,
    loader: false,
    authmodal:false,
    post_fn:null
  }
  showSnackBar = (text) => {
    this.setState({ snackBar: true, snackbarText: text })
  }
  hideSnackBar = () => {
    this.setState({ snackBar: false, snackbarText: null })
  }
  showLoader = () => {
    this.setState({ loader: true })
  }
  hideLoader = () => {
    this.setState({ loader: false })
  }
  showAuthModal = () => {
    this.setState({ authmodal: true })
  }
  hideAuthModal = () => {
    this.setState({ authmodal: false })
  }
  set_post_fn=({post_fn})=>{
    this.setState({post_fn})
  }
  render() {

    const {  state: { snackBar, snackbarText, loader,authmodal,post_fn },
      showSnackBar, hideSnackBar,
      showLoader, hideLoader ,
      showAuthModal, hideAuthModal ,set_post_fn,} = this
    return (

        <ThemeProvider theme={theme}>
          <CssBaseline />
       <LoadingOverlay loader={loader}/>
          <AuthContext.Provider value={{ show: showAuthModal, hide: hideAuthModal ,set_post_fn:set_post_fn}}>
          <SnackBarContext.Provider value={{ show: showSnackBar, hide: hideSnackBar }}>
            <LoaderContext.Provider value={{ show: showLoader, hide: hideLoader }}>


              <Router  basename="/web">
                <Switch>
                  <Route path="/" component={Student} />



                </Switch>
              </Router>
              {snackBar && <SnackBar text={snackbarText} hideSnackBar={hideSnackBar} />}
             {/*{loader && <Loader />}*/}
              {authmodal && <AuthModal  handleClose={hideAuthModal} post_fn={post_fn} />}
            </LoaderContext.Provider>
          </SnackBarContext.Provider>
          </AuthContext.Provider>

        </ThemeProvider>

    );
  }


}
